import { Grid, Typography } from "@material-ui/core";
import EmptyCalatog from "assets/empty_catalog.svg";
import { Column } from "components/Table/Table";
import Table from "components/TableCatalog/Table";
import useText from "constants/text";
import defaultProduct  from "assets/icons/defaultProduct.webp"
import { IProductPick, InationalTransportPoint, ItemAtPoint } from "contexts/RequestQuoteContext";
import { Product } from "generated/graphql";
import React, { useEffect, useMemo, useState } from "react";
import { ContainerProduct } from "../shared/Catalog/CatalogStyles";
import CatalogCounter from "./CatalogCounter";
import { useColumnStyles, useFormStyles } from "./style";


export const useCatalogItemsColumns = (
  text: any,
  selectedProducts: any[],
  newProductsChecked: ItemAtPoint[],
  productsToPick: ItemAtPoint[],
  point: InationalTransportPoint,
  isForDelivery: boolean,
  classes: any,
  onChangeCountValue: (item: Product, counter: number) => void
): Column<Partial<IProductPick>>[] => [
    {
      field: "product",
      title: text.all.article_name,
      render: ({ name, description , photoUrl}) => (
        <Grid container direction="row">
        <div>
          <img src={photoUrl || defaultProduct} alt="product" className={classes.image} />
        </div>
        <div style={{paddingLeft: "5%"}}>
            <span className={classes.text}>
              {name}
            </span>
            <span className={classes.description}>
              {description}
            </span>
          </div>
          </Grid>
      ),
    },
    {
      field: "reference",
      title: text.all.reference,
      render: ({ reference }) => (
        <span className={classes.text}>
          {reference}
        </span>
      ),
    },
    {
      field: "size",
      title: text.all.size,
      render: ({ weight }) => (
        <span className={classes.text}>
          {weight}
        </span>
      ),
    },
    {
      field: "price",
      title: text.all.price,
      render: ({ value }) => (
        <span className={classes.text}>
          {value}
        </span>
      ),
    },
    {
      field: "quantity",
      title: text.all.quantity,
      render: (product) =>
        selectedProducts.includes(product._id) && (
          <CatalogCounter
            product={product}
            isForDelivery={isForDelivery}
            point={point}
            productsChecked={newProductsChecked}
            productsToPick={productsToPick}
            onCounterChanged={false}
            onChangeCountValue={onChangeCountValue}
          />
        ),
    },
  ];

interface ICatalog {
  onValidate: (stop: InationalTransportPoint, products: ItemAtPoint[]) => void;
  productsChecked: ItemAtPoint[];
  products: IProductPick[];
  isForDelivery?: boolean;
  productsToPick?: ItemAtPoint[];
  positionPoint?: number;
  point?: InationalTransportPoint;
  onSubmit: boolean;
  close: () => void;
  newProductsChecked: ItemAtPoint[];
  setNewProductsChecked: React.Dispatch<React.SetStateAction<ItemAtPoint[]>>;
}

export default function FromCatalog({
  onValidate,
  productsChecked,
  products,
  isForDelivery,
  productsToPick,
  point,
  onSubmit,
  close,
  newProductsChecked,
  setNewProductsChecked,
}: ICatalog) {
  const { text } = useText();
  const classes = useFormStyles();
  const styles = useColumnStyles();

  const getCheckedIdsFromCatalog = useMemo(() => {
    if (productsChecked?.length > 0 && products?.length > 0) {
      const allIds = productsChecked?.map((prod) => prod?.product?._id);
      const catalogIds = products?.map((prod) => prod._id);
      return allIds.filter((id) => catalogIds.includes(id));
    }
  }, [productsChecked, products]);

  const getNonSavedCheckedIds = useMemo(() => {
    if (newProductsChecked?.length > 0 && products?.length > 0) {
      const allIds = newProductsChecked?.map((prod) => prod?.product?._id);
      const catalogIds = products?.map((prod) => prod._id);
      return allIds.filter((id) => catalogIds.includes(id));
    }
  }, [newProductsChecked, products]);

  const [selectedProducts, setSelectedProducts] = useState(getNonSavedCheckedIds || getCheckedIdsFromCatalog || []);

  const onProductItemChecked = (item: IProductPick) => {
    const selectedIndex = newProductsChecked?.findIndex((o) => o?.product?._id === item?._id);

    if (selectedIndex === -1) {
      const newItem = {
        product: item,
        counter: 0,
        remainder: 0,
      };
      setNewProductsChecked([...newProductsChecked, newItem]);
    }
  };

  const handleProductChecked = (product: IProductPick) => {
    const prod = JSON.parse(JSON.stringify(product));
    prod.refPickupDelivery = product._id;
    onProductItemChecked(prod);
  };

  const onProductCounterChanged = (item: IProductPick, counter: number) => {
    const arrayOFproduct = newProductsChecked;

    const objIndex = newProductsChecked?.findIndex((o) => o?.product?._id === item?._id);

    if (objIndex !== -1) {
      const newValue = counter - arrayOFproduct[objIndex].counter;
      arrayOFproduct[objIndex].remainder += newValue;
      arrayOFproduct[objIndex].counter = counter;
    } else {
      const newItem: ItemAtPoint = {
        product: item,
        counter,
        remainder: counter,
      };
      arrayOFproduct.push(newItem);
    }

    setNewProductsChecked([...arrayOFproduct]);
  };

  const onChangeCountValue = (product: IProductPick, counter: number) => {
    onProductCounterChanged(product, counter);
  };

  useEffect(() => {
    if (selectedProducts.length > 0) {
      if (selectedProducts?.length < newProductsChecked?.length) {
        const unselectedId = newProductsChecked.filter((item) => !selectedProducts.includes(item.product._id));
        unselectedId.map((unselected) => {
          const newArrayOfProducts = newProductsChecked.filter((item) => item.product._id !== unselected.product._id);
          setNewProductsChecked([...newArrayOfProducts]);
        });
      } else {
        const product = products.find((prod) => prod._id === selectedProducts[selectedProducts.length - 1]);
        handleProductChecked(product);
      }
    }
  }, [selectedProducts]);

  const columns = useCatalogItemsColumns(
    text,
    selectedProducts,
    newProductsChecked,
    productsToPick,
    point,
    isForDelivery,
    styles,
    onChangeCountValue,
  );

  return (
    <ContainerProduct>
      {products?.length > 0 ? (
        <Table
          hasSelection
          columns={columns}
          data={products}
          rowsIdentifier="_id"
          rowsPerPage={products.length}
          onRowChecked={setSelectedProducts}
          selectedRows={selectedProducts}
        />
      ) : (
        <Grid container direction="column" spacing={6} className={classes.text_info} >
          <Grid item xs={12}>
            <img src={EmptyCalatog} alt={text.all.no_product_found_in_catalogue} style={{ width: 250 }} />
          </Grid>
          <Typography variant="h4" color="primary">
            {text.all.no_product_found_in_catalogue}
          </Typography>
        </Grid>
      )}
    </ContainerProduct>
  );
}
